import { useSetBreadcrumb } from '@/components/layout/BreadcrumbContext'
import {
  facilityFinancialAccountsLabel,
  financialAccountsBasePath,
  type FacilityFinancialAccountsScope,
} from './financialAccountsScope'

/**
 * Name the facility's Financial Accounts crumb "{Facility} Financial Accounts"
 * on the facility page and every page below it. The label is registered under
 * the facility page's PATH (not a segment value), which `Breadcrumbs` checks
 * for the `financial-accounts` crumb of a facility route; it hides the facility
 * id segment there, so the facility reads as one crumb. No-op without a scope.
 */
export function useFacilityScopeBreadcrumb(scope: FacilityFinancialAccountsScope | null): void {
  useSetBreadcrumb(
    scope ? financialAccountsBasePath(scope) : null,
    scope ? facilityFinancialAccountsLabel(scope.facilityName) : null,
  )
}
